<template>
  <v-dialog v-model="dialog" persistent width="500">
    <template v-slot:activator="{ on }">
      <v-btn color="red lighten-2" dark v-on="on">
        <span v-if="value.hardwareSerial">{{ value.hardwareSerial }}</span>
        <span v-else>Attach Serail Number</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Searil Number
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-flex>
            <v-text-field
              ref="serialNumber"
              label="Serial Number"
              v-model="serialNumber"
            ></v-text-field>
          </v-flex>
          <v-flex shrink>
            <v-btn color="success" @click="searchSerial()">Search</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text v-if="purchase">
        <div>
          Name:
          <span class="font-weight-medium">{{ purchase.Product.productDetail }}</span>
        </div>
        <div>
          Price:
          <span class="font-weight-medium">{{ purchase.Product.amount | currency }}</span>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="primary" flat @click="dialog = false">
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!purchase" @click="attach">
          Attached
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceService from '../service.js';

export default {
  props: ['value'],
  data() {
    return {
      removeSerialNumber: true,
      purchase: null,
      dialog: false,
      serialNumber: null
    };
  },
  created() {
    console.log('value', this.value);
  },
  watch: {
    dialog(val) {
      if (val) {
        delete this.value['purchase'];
        this.$nextTick(() => {
          this.$refs.serialNumber.focus();
        });
      }
    }
  },
  methods: {
    clear() {
      this.serialNumber = null;
      this.purchase = null;
      this.dialog = false;
    },
    attach() {
      const newValue = this.value;
      newValue.hardwareSerial = this.serialNumber;
      newValue.purchase = this.purchase;
      // newValue.hardwareSerial = this.serialNumber;
      console.log('hardwareSerial', newValue);
      this.$emit('input', newValue);
      // this.$emit('attach', {purchase: this.purchase, serialNumber: this.serialNumber})
      this.clear();
    },
    searchSerial() {
      return invoiceService
        .searchSerialNumber({ serialNumber: this.serialNumber, productID: this.value.productID })
        .then(result => {
          // console.log('searchSerialNumber', result)
          this.purchase = result.data;
          if (!this.purchase) {
            this.$swal({
              title: 'Serial Number Not Found',
              text: 'Serial Number you endterd is not found please trying using another number.',
              type: 'warning'
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
